import React from "react";
import {
  Typography,
  Autocomplete,
  TextField,
  Checkbox,
  Box,
} from "@mui/material";

const AttributeField = ({ label, options, selectedIds, onChange }) => {
  // Ensure consistent string comparison
  const normalizedSelected = options.filter((opt) =>
    selectedIds.map(String).includes(String(opt._id))
  );

  return (
    <>
      <Typography mt={2} fontWeight={600}>
        {label}
      </Typography>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={options}
        getOptionLabel={(option) => option.name}
        value={normalizedSelected}
        onChange={(event, newValue) =>
          onChange(newValue.map((opt) => String(opt._id)))
        }
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox checked={selected} sx={{ mr: 1 }} />
            {option.name}
          </li>
        )}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label={label} />
        )}
        sx={{ mt: 1, mb: 3 }}
        ListboxProps={{
          style: {
            maxHeight: 300,
            overflowY: "auto",
          },
        }}
      />
    </>
  );
};

const CakeAttributesSelector = ({ attributeOptions, value, onChange }) => (
  <>
    <AttributeField
      label="Decor"
      options={attributeOptions.decor}
      selectedIds={value.filter((id) =>
        attributeOptions.decor.some((d) => d._id === id)
      )}
      onChange={(newIds) => onChange("decor", newIds)}
    />
    <AttributeField
      label="Style"
      options={attributeOptions.designPattern}
      selectedIds={value.filter((id) =>
        attributeOptions.designPattern.some((d) => d._id === id)
      )}
      onChange={(newIds) => onChange("designPattern", newIds)}
    />
  </>
);

export default CakeAttributesSelector;
